// components
import PageHeading from "../components/PageHeading";
import BasketInformation from "../components/BasketInformation";
// @interfaces
import { IBasket } from "../@interfaces/basket.interface";
import { IPurchase } from "../@interfaces/purchase.interface";
// styles
import styles from '../styles/pages/confirmation/PaymentConfirmationPage.module.css';
import Button from "../components/Button";
import Footer from "../components/Footer";
import {IWidgetConfiguration} from "../merchantConfig";

interface PaymentConfirmationPageProps {
  purchase: IPurchase | null,
  userEmail: string | null,
  basket: IBasket | null,
  merchantCode: string;
  language: string | null;
  widgetConfiguration: IWidgetConfiguration;
  setActiveStep: (step: number) => void;
}

const PaymentConfirmationPage: React.FC<PaymentConfirmationPageProps> = ({
  purchase,
  userEmail,
  language,
  basket,
  merchantCode,
  widgetConfiguration,
  setActiveStep
}) => {

  return (
      <div className={`${styles.container} delayed-fadein`}>
        <div>
            <PageHeading
              title={'Thank you!'}
              activeStep={2}
              setActiveStep={setActiveStep}
            />

            <div className={styles.marginTop}>
              <p className={styles.textBold}>{"Your payment was successful."}</p>
            </div>

            <div className={styles.marginTop}>
                {/*For weglot translation purposes we don't have any spans here; keep it simple so that the weglot.com variable system works*/}
                <p className={styles.textBody}>Your purchase reference is {purchase?.orderReference}. We’ve sent a confirmation to {userEmail} .</p>
            </div>

            <div className={styles.marginTop}>
              <p style={{marginBottom: '4px'}} className={styles.textBold}>{"Supported projects"}</p>
              <BasketInformation merchantCode={merchantCode} projects={basket?.projects} />
            </div>
        </div>
        <div>
            <div className={styles.traceTextContainer}>
              <p className={styles.textBody}>You can trace your contribution and learn about the climate projects you are supporting.</p>
            </div>

            <div className={styles.marginTop}>
              <Button
                  variant={'primary'}
                  isLoading={false}
                  text={"Trace my contribution"}
                  href={`${process.env.REACT_APP_MY_CC_URL}/RM-${merchantCode}/transaction/${purchase?.purchaseId}${language ? '?lang=' + language : ''}`}
              />
            </div>
        </div>
        {!widgetConfiguration.hidePoweredBy && <Footer/>}
      </div>
  )
};

export default PaymentConfirmationPage;
